/* eslint-disable react-refresh/only-export-components */
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { FC, StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import LoadingPage from './components/LoadingPage';
import LocalizationWrapper from './components/LocalizationWrapper';
import { AppDependenciesProvider } from './context/AppDependenciesContext';
import { AppRuntimeProvider } from './context/AppRuntimeContext';
import { AuthProvider } from './context/AuthContext';
import './i18n';
import './index.css';
import AppRouter from './Router';
import { initSentry } from './sentry';
import { createAppDependencies } from './infrastructure/appDependencies';
import { createAppRuntime } from './infrastructure/appRuntime';
import { createFirebaseEnvironment } from './infrastructure/firebase/firebaseEnvironment';
import theme from './theme';
import { initWebVitals } from './utils/webVitals';

initSentry();
initWebVitals();
const firebaseEnvironment = createFirebaseEnvironment();
const appDependencies = createAppDependencies(firebaseEnvironment);
const appRuntime = createAppRuntime(appDependencies);

const AppWithTheme: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppDependenciesProvider value={appDependencies}>
        <AppRuntimeProvider value={appRuntime}>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </AppRuntimeProvider>
      </AppDependenciesProvider>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Provider store={appRuntime.store}>
      <PersistGate loading={<LoadingPage minHeight="100vh" />} persistor={appRuntime.persistor}>
        <LocalizationWrapper>
          <AppWithTheme />
        </LocalizationWrapper>
      </PersistGate>
    </Provider>
  </StrictMode>
);
